/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDCornerUpRightIcon20Light = forwardRef('ArrowDCornerUpRightIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M12.854 1.646a.5.5 0 0 0-.708.708L16.793 7H6a3 3 0 0 0-3 3v8.5a.5.5 0 0 0 1 0V10a2 2 0 0 1 2-2h10.793l-4.647 4.646a.5.5 0 0 0 .708.708l4.651-4.652a1.7 1.7 0 0 0 0-2.404l-4.651-4.652Z" })));
});
